module.exports = __webpack_public_path__ + "static/img/18-2.0ae096f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/18-2.jpg
// module id = Kpxh
// module chunks = 0